module.exports = __webpack_public_path__ + "static/media/guanyuwomen_wap.22dcd0c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/about/guanyuwomen_wap.svg
// module id = 680
// module chunks = 0